import { createSlice } from '@reduxjs/toolkit'
import { getActiveMembershipPlanDetailACTION, getAllMembershipPlanACTION, membershipPlanBuyAction, membershipPlanPaymentConfirmationACTION } from '../actions/membership.Actions';

const INITIAL_STATE = {
    activeMembership: null,
    activeMembershipPlanDetail: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        }
    },
    allMembershipPlan: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        }
    },
    membershipPaymentConfirmation: {
        data: null,
        newMembership: false,
        apiMsg: {
            message: null,
            status: null,
            error: null
        }
    },
    membershipPlanBuy: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        }
    }
};

const membershipPlanReducer = createSlice({
    name: 'MembershipPlan',
    initialState: INITIAL_STATE,
    reducers: {
        setNewMembershipFlag(state, action) {
            state.membershipPaymentConfirmation.newMembership = action.payload;
        },
        setActiveMembership(state, action) {
            state.activeMembership = action.payload;
        },
        RESET_MEMBERSHIP_PAYMENT_CONFIRMATION(state, action) {
            state.membershipPaymentConfirmation = INITIAL_STATE.membershipPaymentConfirmation;
            state.membershipPlanBuy = INITIAL_STATE.membershipPlanBuy;
        },
        RESET_MEMBERSHIP_DETAIL(state, action) {
            state.activeMembershipPlanDetail = INITIAL_STATE.activeMembershipPlanDetail;
        },
        RESET_MEMBERSHIP_BUY(state, action) {
            state.placeOrder = INITIAL_STATE.placeOrder;
        }
    },
    extraReducers: (builder) => {

        builder.addCase(getActiveMembershipPlanDetailACTION.fulfilled, (state, action) => {
            state.activeMembershipPlanDetail.data = action.payload.data
            state.activeMembershipPlanDetail.apiMsg.status = action.meta.requestStatus;
            state.activeMembershipPlanDetail.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getActiveMembershipPlanDetailACTION.pending, (state, action) => {
            state.activeMembershipPlanDetail.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getActiveMembershipPlanDetailACTION.rejected, (state, action) => {
            state.activeMembershipPlanDetail.apiMsg.message = action.error.message;
            state.activeMembershipPlanDetail.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getAllMembershipPlanACTION.fulfilled, (state, action) => {
            state.allMembershipPlan.data = action.payload.data
            state.allMembershipPlan.apiMsg.status = action.meta.requestStatus;
            state.allMembershipPlan.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getAllMembershipPlanACTION.pending, (state, action) => {
            state.allMembershipPlan.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllMembershipPlanACTION.rejected, (state, action) => {
            state.allMembershipPlan.apiMsg.message = action.error.message;
            state.allMembershipPlan.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(membershipPlanPaymentConfirmationACTION.fulfilled, (state, action) => {
            state.membershipPaymentConfirmation.data = action.payload.data
            state.membershipPaymentConfirmation.apiMsg.status = action.meta.requestStatus;
            state.membershipPaymentConfirmation.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(membershipPlanPaymentConfirmationACTION.pending, (state, action) => {
            state.membershipPaymentConfirmation.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(membershipPlanPaymentConfirmationACTION.rejected, (state, action) => {
            state.membershipPaymentConfirmation.apiMsg.message = action.error.message;
            state.membershipPaymentConfirmation.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(membershipPlanBuyAction.fulfilled, (state, action) => {
            state.membershipPlanBuy.data = action.payload.data
            state.membershipPlanBuy.apiMsg.status = action.meta.requestStatus;
            state.membershipPlanBuy.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(membershipPlanBuyAction.pending, (state, action) => {
            state.membershipPlanBuy.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(membershipPlanBuyAction.rejected, (state, action) => {
            state.membershipPlanBuy.apiMsg.message = action.error.message;
            state.membershipPlanBuy.apiMsg.status = action.meta.requestStatus;
        });

    }
})

export const { setNewMembershipFlag, setActiveMembership, RESET_MEMBERSHIP_PAYMENT_CONFIRMATION, RESET_MEMBERSHIP_DETAIL, RESET_MEMBERSHIP_BUY } = membershipPlanReducer.actions;
export default membershipPlanReducer.reducer;